module.exports = __webpack_public_path__ + "static/media/fasad14.1b975433.jpeg";